/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */

define(['backbone', 'underscore', 'assets/js/modules/widgets/pricingCalculator/model/pricingCalcSideModel'], function(
    backbone,
    _,
    PricingCalcSideModel
) {
    var PricingCalculatorService = function() {};

    PricingCalculatorService.prototype = {
        /**
         * @param {SkuModel[]} skus
         * @returns {PricingCalcSideModel[]}
         */
        createSides: function(skus) {
            var sideNumbers = _.unique(skus.pluck('sides'));

            var sides = new backbone.Collection();
            _.each(sideNumbers, function(sideNumber) {
                sides.add(
                    new PricingCalcSideModel({
                        sides: parseInt(sideNumber)
                    })
                );
            });

            return sides;
        }
    };

    return new PricingCalculatorService();
});
